const state = {
  toggle: true
}

const actions = {
  toggle ({ commit }, boolean) {
    commit('toggle', boolean)
  }
}

const mutations = {
  toggle ({ commit }, boolean) {
    state.toggle = boolean
  }
}

const mainMenu = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default mainMenu
